import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../../styles/stylesConstants';
import { themeColors } from '../../../styles/themeColors';
//"scrollbar.shadow": "#23272c",
export default makeStyles((theme: Theme) => ({
  container: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(2),
    boxShadow: theme.shadows[1],
    width: stylesConstants.contentContainerMinWidth,
  },
  tableContainer: {
    borderRadius: theme.spacing(1),
    border: stylesConstants.defaultBorder,
    overflow: 'hidden',
    margin: theme.spacing(2),
  },
  tableContentContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  tableLabel: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  buttonContainer: {
    margin: theme.spacing(2),
    marginLeft: 'auto',
    marginTop: 0,
  },
  buttonDeactivatePlan: {
    marginLeft: 'auto',
    '&.MuiButton-root': {
      height: 30,
    },
  },
  cellWidth: {
    width: '16%',
  },
  titleCellWidth: {
    width: '20%',
  },
  buttonCustomer: {
    margin: theme.spacing(2),
    marginLeft: 'auto',
  },
}));
